import { Component, forceUpdate, h } from "@stencil/core";
import { scrollToTop } from "../../utils/scroll-to-top";
import { ButtonSize } from "../button/button.enum";
import { i18nProvider } from "@trumpf/ux.i18n";

@Component({
    tag: "ux-scroll-to-top-button",
    styleUrl: "scroll-to-top-button.scss",
    shadow: true
})
export class ScrollToTopButton {
    componentWillLoad() {
        i18nProvider.subscribe(() => {
            forceUpdate(this);
        });
    }

    render() {
        const { t } = i18nProvider;

        return (
            <ux-button aria-label={t("scrollToTop.label")} onClick={() => scrollToTop()} size={ButtonSize.Icon}>
                <ux-icon slot="icon" aria-hidden="true" name="arrow-up" weight="normal" />
            </ux-button>
        );
    }
}
